import { registerLocale } from "react-datepicker";

// TODO: this will have to be reviewed when there will be completed translations solution.
// Maybe there is way to load locales dynamically (depending on defined all available locales in next-i18next.config.js)

import en from "date-fns/locale/en-GB";
import ee from "date-fns/locale/et";
import lt from "date-fns/locale/lt";
import lv from "date-fns/locale/lv";
import ru from "date-fns/locale/ru";

export const registerLocales = () => {
  registerLocale("en", en);
  registerLocale("ee", ee);
  registerLocale("lt", lt);
  registerLocale("lv", lv);
  registerLocale("ru", ru);
};
